<template>
  <div class="chartwrapper">
    <canvas :id="name"></canvas>
  </div>
</template>
<script>
  import moment from 'moment';
  import store from "../../store/store";

  export default {
    data() {
      return {
        // chart: null,
        colors: [
          'rgba(192,216,73,0.50)',
          'rgba(244,116,39,0.50)',
          'rgba(250,226,57,0.50)',
          'rgba(24,139,113,0.50)',
          'rgba(237,28,36,0.50)',
          'rgba(7,67,87,0.50)',
          'rgba(13,147,207,0.5)',
          'rgba(90,90,90,0.50)',
        ],
        chart: {},
        options: {
          legend: {
            labels: {
              // borderWidth:0,
              usePointStyle: true,
              fontStyle: 'Light',
              fontFamily: 'Roboto'
            },
            align: 'end',
            position: 'bottom'
          },
          scales: {
            xAxes: [{
              gridLines: {
                color: '#5f6165',
                drawOnChartArea: false,
                borderDashOffset: 5
              },
            }],
            yAxes: [{
              gridLines: {
                color: '#5f6165',
                drawOnChartArea: false,
                display: false
              },
              ticks: {

                stepSize: 1,
                min: 0,
                max: 7,
                beginAtZero: true
              }
            }]
          }
        },
        rawData: {}
      }
    },
    computed: {
      name() {
        return this.type + '-' + this.entity.id + '-linechart'
      },
      datasets() {
        const datasets = [];
        const dates = this.getDatesBetween(this.start, this.end, 'YYYY-MM-DD');

        if (dates.length === 1) {
          dates.push(dates[0]) //hack to span line over entire chart when only 1 date is selected
        }

        let vipScores = [];
        for (let vitaminId in this.vitaminScores) {
          this.vitaminScores[vitaminId].evolution = []
        }

        const pushData = (data) => {
          vipScores.push(data ? this.truncate(data.vipscore, 2) : null);
          for (let vitaminId in this.vitaminScores) {
            this.vitaminScores[vitaminId].evolution.push(data ? this.truncate(data[vitaminId], 2) : null)
          }
        };

        if (this.rawData) {
          if (this.rawData.data) {
            let len = Object.keys(this.rawData.data).length;
            dates.forEach((date, dateIndex) => {
              // if (dateIndex === (len - 2) && dateIndex !== (dates.length - 1)) {
              //   console.log('last datapoint',date)
              //   pushData(null)
              // } else
                if (
                  dateIndex === 0 ||
                  dateIndex === (dates.length - 1)
                ) {
                if (this.rawData.data[date]) {
                  pushData(this.rawData.data[date])
                } else {
                  let data = null;
                  for (let i = 0; i <= len; i++) {
                    let newdate = moment(date).subtract(i, 'days').format('YYYY-MM-DD');
                    data = this.rawData.data[newdate];
                    if (data) {
                      break;
                    }
                  }
                  pushData(data)
                }
              } else {
                pushData(this.rawData.data[date])
              }
            });

            datasets.push(this.makeDataSetObject(vipScores, this.$t('message.score'), this.colors[0]));

            let c = 1;
            for (let vitaminId in this.vitaminScores) {
              datasets.push(this.makeDataSetObject(this.vitaminScores[vitaminId].evolution, this.localizedField(this.vitaminScores[vitaminId], 'Title'), this.colors[c]));
              c++;
            }
          }
        }

        return {
          datasets: datasets,
          labels: this.getDatesBetween(this.start, this.end)
        };

      }
    },
    watch: {
      start() {
        this.initChart()
      },
      end() {
        this.initChart()
      },
      datasets() {
        this.initChart()
      },
    },
    mounted() {
      this.initChart()
    },
    created() {
      this.getGraphData()
    },
    methods: {
      initChart() {
        let type = 'line';
        let dates = this.getDatesBetween(this.start, this.end)
        if (dates.length === 1) {
          type = 'bar';
          this.datasets.datasets.forEach(dataset => {
            dataset.fill = true
          })
        }

        if (this.chart.destroy) {
          this.chart.destroy();
        }

        this.chartEl = document.getElementById(this.name);
        this.chart = new Chart(this.chartEl, {
          type: type,
          data: this.datasets,
          options: this.options
        });
      },
      makeDataSetObject(data, label, color) {
        return {
          label: label,
          data: data,
          // borderWidth: 0,
          borderColor: color,
          cubicInterpolationMode: 'monotone',
          pointStyle: 'circle',
          backgroundColor: color,
          borderWidth: 2,
          pointBorderWidth: 0,
          spanGaps: true,
          fill: false,
          pointBackgroundColor: color,
          pointRadius: 2
        }
      },

      async getGraphData() {
        let ep = '';
        switch (this.type) {
          case 'user':
            ep = '/graphs?type=' + this.type + '&subtype=' + this.entity.id;
            break;
          case 'team':
            ep = '/graphs?type=' + this.type + '&subtype=' + this.entity.id;
            break;
          case 'company':
            ep = '/graphs?type=' + this.type + '&subtype=' + 0;
            break;
        }

        const mainData = await this.axios.get(ep);
        this.rawData = mainData.data[0];

      }
    },
    props: {
      vitaminScores: {
        type: Object, default() {
          return {}
        }
      },
      start: {
        type: String,
        default() {
          return moment().subtract(14, 'days').format('YYYY-MM-DD')
        }
      },
      end: {
        type: String,
        default() {
          return moment().format('YYYY-MM-DD')
        }
      },
      type: {
        type: String,
        default() {
          // options: user/company/team
          return 'user'
        }
      },
      entity: {
        type: Object,
        default() {
          return null
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Charts/EvolutionChart.vue